import { Box } from "@mui/material";

type Props = {
  dataSrc: string;
  label: string;
};

export const ImageDetail = ({ dataSrc, label }: Props) => (
  <Box position="relative" maxWidth={800} width="100%">
    {/* Image layer - no pointer events */}
    <Box
      component="img"
      src={dataSrc}
      alt={label}
      width="100%"
      height="auto"
      borderRadius={1}
      draggable={false}
      sx={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        WebkitTouchCallout: "none", // Disable iOS long-press save
        pointerEvents: "none", // Image itself can't be interacted with
      }}
    />

    {/* Transparent overlay to block all interactions */}
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      sx={{
        cursor: "default",
      }}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    />
  </Box>
);
